import React from 'react';
import {Redirect} from 'react-router-dom';

// `condition` is a function that accepts `props` and returns true if `Component` is allowed to
// render, false if the user should be redirected to `redirectUrl`.
const ConditionalRedirect = ({condition, redirectUrl = '/'}) => Component => props => (
  condition(props) === true
    ? <Component {...props} />
    : <Redirect to={redirectUrl} />
);

export default ConditionalRedirect;



// WEBPACK FOOTER //
// ./public/hoc/ConditionalRedirect.jsx